<div class="featured-chef-container" [style.background-image]="getImage()">
  <div class="overlay"></div>
  <div class="chef-details-div">
<!--    <p class="chef-name">{{ chefName }} / {{ cuisineName }}</p>-->
    <p class="chef-name">{{ chefName }}</p>

    <div class="merchant-details" (click)="viewMerchant()">
      <p i18n="@@viewProfile">View profile</p>
    </div>
  </div>
</div>
